<template>
  <div v-if="dashboard_data.users!=null">
    <CRow>
      <CCol sm="6" lg="3">
        <CWidgetDropdown color="primary" :header="dashboard_data.users" text="تعداد کارمندان">
          <template #default>
            <CDropdown
                color="transparent p-0"
                placement="bottom-end"
            >
              <template #toggler-content>
                <CIcon name="cil-settings"/>
              </template>
              <CDropdownItem>Action</CDropdownItem>
              <CDropdownItem>Another action</CDropdownItem>
              <CDropdownItem>Something else here...</CDropdownItem>
              <CDropdownItem disabled>Disabled action</CDropdownItem>
            </CDropdown>
          </template>
          <template #footer>
            <CChartLineSimple
                pointed
                class="mt-3 mx-3"
                style="height:70px"
                :data-points="[65, 59, 84, 84, 51, 55, 40]"
                point-hover-background-color="primary"
                label="Members"
                labels="months"
            />
          </template>
        </CWidgetDropdown>
      </CCol>
      <CCol sm="6" lg="3">
        <CWidgetDropdown color="primary" :header="dashboard_data.last_month_salary" text="حقوق ماه قبل">
          <template #default>
            <CDropdown
                color="transparent p-0"
                placement="bottom-end"
            >
              <template #toggler-content>
                <CIcon name="cil-settings"/>
              </template>
              <CDropdownItem>Action</CDropdownItem>
              <CDropdownItem>Another action</CDropdownItem>
              <CDropdownItem>Something else here...</CDropdownItem>
              <CDropdownItem disabled>Disabled action</CDropdownItem>
            </CDropdown>
          </template>
          <template #footer>
            <CChartLineSimple
                pointed
                class="mt-3 mx-3"
                style="height:70px"
                :data-points="[65, 59, 84, 84, 51, 55, 40]"
                point-hover-background-color="primary"
                label="Members"
                labels="months"
            />
          </template>
        </CWidgetDropdown>
      </CCol>
      <CCol sm="6" lg="3">
        <CWidgetDropdown color="primary" :header="dashboard_data.last_month_extra" text="اضافه کار ماه قبل">
          <template #default>
            <CDropdown
                color="transparent p-0"
                placement="bottom-end"
            >
              <template #toggler-content>
                <CIcon name="cil-settings"/>
              </template>
              <CDropdownItem>Action</CDropdownItem>
              <CDropdownItem>Another action</CDropdownItem>
              <CDropdownItem>Something else here...</CDropdownItem>
              <CDropdownItem disabled>Disabled action</CDropdownItem>
            </CDropdown>
          </template>
          <template #footer>
            <CChartLineSimple
                pointed
                class="mt-3 mx-3"
                style="height:70px"
                :data-points="[65, 59, 84, 84, 51, 55, 40]"
                point-hover-background-color="primary"
                label="Members"
                labels="months"
            />
          </template>
        </CWidgetDropdown>
      </CCol>


    </CRow>
  </div>
</template>

<script>

import {bus} from "../main";
import axios from "axios";
import {CChartLineSimple, CChartBarSimple} from './charts/index.js'

export default {
  name: 'Dashboard',
  components: {CChartLineSimple, CChartBarSimple},

  data() {
    return {
      dashboard_data: {},
      today_total_payments: 0,
    }
  },
  computed: {},
  mounted() {

    this.get_dashboard_data();

  },
  methods: {
    get_dashboard_data() {
      var self = this;

      const formData = new FormData();

      axios.post('/dashboard_data', formData, {}).then(function (response) {


        self.dashboard_data = response.data;

        // self.dashboard_data.total_payments.forEach(function (val){
        // self.today_total_payments +=val.price.total_price
      // self.today_total_payments += self.dashboard_data.total_payments_extra
      //
      // document.getElementById("ticket_badge").innerText = self.dashboard_data.tickets_non_answered
      // if (JSON.parse(self.dashboard_data.reseler).balance < 10) {
      //   self.$root.modal_component.show_danger_modal("اخطار", "حساب نمایندگی ایرنیک را شارژ کنید");
      //
      // }

    }
)
.catch(function (error) {

  console.log(error);
});

},


},
}
</script>
<style>
.bg-revenue .nav-link.active {
  background: #3399FF;
  color: white;
}

.bg-sale .nav-link.active {
  background: #f9b115;
  color: white;
}

.bg-profit .nav-link.active {
  background: #2eb85c;
  color: white;
}
</style>
